/**
 * @file   src\Pages\SignUp.tsx
 * @brief  Login page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import {  Container, Button, Row, Col} from '../utils/thirdpartyComponents';

const SignIn = () => {
return (
   
    <div>signup</div>
)
}

export default SignIn;
